import React, { useState } from "react";
import launchpadData from "./launchpadData";
import LaunchpadDetails from "./LaunchpadDetails";
import LaunchpadGrid from "./LaunchpadGrid";

const LaunchpadHome = ({ mode = "learner" }) => {
  const [selectedTrack, setSelectedTrack] = useState(null);
  const isTenantMode = mode === "tenant";

  return (
    <div className="min-h-screen bg-[#F1F7FF] text-body flex flex-col items-center p-4">
      {/* Branded Header */}
      <div className="w-full bg-white/80 backdrop-blur-md border-b border-blue-100 py-4 px-8 mb-8 flex justify-between items-center rounded-2xl shadow-sm">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-secondary rounded-xl flex items-center justify-center text-white font-black">
            SG
          </div>
          <h1 className="text-xl font-black text-gray-900 tracking-tight">
            TheSkillGenie
          </h1>
        </div>
        {isTenantMode && (
          <div className="bg-secondary/10 border border-secondary/30 px-4 py-1.5 rounded-full">
            <span className="text-secondary font-black text-[10px] uppercase tracking-widest">
              Institutional Access
            </span>
          </div>
        )}
      </div>

      <div className="max-w-[1200px] w-full p-8 rounded-[3rem] bg-white shadow-xl shadow-blue-900/5 relative overflow-hidden">
        {/* Background Accents */}
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-primary/5 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-secondary/5 rounded-full blur-3xl"></div>

        {!selectedTrack ? (
          <>
            <div className="mb-10 text-center relative z-10">
              <h2 className="text-4xl font-black text-gray-900 uppercase tracking-tighter mb-2">
                {isTenantMode ? "College Launchpad" : "Launchpad"}
              </h2>
              <p className="text-gray-400 font-bold uppercase text-[10px] tracking-[0.2em]">
                {isTenantMode
                  ? "Guided Institutional Tracks"
                  : "Accelerate your career with guided paths"}
              </p>
            </div>
            <LaunchpadGrid onLaunchpadClick={setSelectedTrack} />
          </>
        ) : (
          <LaunchpadDetails
            selectedLaunchpad={selectedTrack}
            onBack={() => setSelectedTrack(null)}
          />
        )}
      </div>
    </div>
  );
};

export default LaunchpadHome;



